import Layout from "../include/layout";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import $ from "jquery";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { myroutes } from "../../routes/webroute";
import Swal from "sweetalert2";
import { checkAuthenticate } from "../app/providers/authSlice";
import "datatables.net-bs5";
//import { Button } from 'primereact/button';
import ClassesService from "./ClassesService";
import { Button, Form, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CustomAddModal from "../../components/CustomAddModal";
import CustomEditModal from "../../components/CustomEditModal";
import Filarial from "../include/filarial";
import Joi from "joi-browser";
import StatutsService from "../statuts/StatutsService";
import SitesService from "../sites/SitesService";

export default function ClassesIndex() {
  const activeLink = "CLASSES"

  const token = useSelector((state) => state.auth.token);
  const [classes, setClasses] = useState([]);
  const [sites, setSites] = useState([])
  const navigate = useNavigate();
  //check if user is authenticated
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticate);
  const [statuts, setStatuts] = useState([])

  const [isVisible, setIsVisible] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [errors, setErrors] = useState({});

  const [addFormData, setAddFormData] = useState({
    libelleClasse: '',
    descriptionClasse: '',
    codeClasse: '',
    subdivisionClasse: '',
    capaciteClasseOption: '',
    montantClasseOption: '',
    idSite: ''
  });

  //declaration des variables pour le form d'edition
  const [editFormData, setEditFormData] = useState({
    libelleClasse: '',
    descriptionClasse: '',
    codeClasse: '',
    subdivisionClasse: '',
    capaciteClasseOption: '',
    montantClasseOption: '',
    id: '',
    idSite: ''
  });

  //####GESTION DES REGLES DE VALIDATIONS ###########///
  const schemaAddData = {
    libelleClasse: Joi.string().min(2).max(100).required().empty('').options({
      language: {
        any: { required: 'le champ est obligatoire' },
        string: { min: "minimum 2 caractères", max: "maximum 100" },
      },
    }).label("Libelle"),

    descriptionClasse: Joi.string().min(0).max(1000).empty('').options({
      language: {
        string: { max: "maximum 1000" },
      },
    }).label("Description"),

    codeClasse: Joi.string().min(0).max(1000).empty('').options({
      language: {
        string: { max: "maximum 1000" },
        any: { required: 'le champ est obligatoire' },
      },
    }).label("Code"),

    subdivisionClasse: Joi.number().integer().min(1).required().empty('').options({
      language: {
        any: { required: 'le champ est obligatoire' },
        number: { min: "minimum 2 caractères", integer: 'Doit être un nombre entier' },
      },
    }).label("Subdivision"),

    capaciteClasseOption: Joi.number().integer().min(1).required().empty('').options({
      language: {
        any: { required: 'le champ est obligatoire' },
        number: { min: "minimum 2 caractères", integer: 'Doit être un nombre entier' },
      },
    }).label("Capacité"),

    montantClasseOption: Joi.number().integer().min(1).required().empty('').options({
      language: {
        any: { required: 'le champ est obligatoire' },
        string: { number: 'vous devez renseignez un nombre' },
      },
    }).label("Montant"),

    idSite: Joi.number().required("").empty('').options({
      language: {
        any: { required: 'le champ est obligatoire' },
      },
    }).label("Site"),
  };

  //GESTION DES REGLES POUR LES FORMULAIRES D'EDITION
  const schemaEditData = {
    id: Joi.number().min(1).empty('').options({
      language: {
        number: { min: "minimum 1" },
      },
    }).label("Id"),

    libelleClasse: Joi.string().min(2).max(100).required().empty('').options({
      language: {
        any: { required: 'le champ est obligatoire' },
        string: { min: "minimum 2 caractères", max: "maximum 100" },
      },
    }).label("Libelle"),

    descriptionClasse: Joi.string().min(0).max(1000).empty('').options({
      language: {
        string: { max: "maximum 1000" },
      },
    }).label("Description"),

    codeClasse: Joi.string().min(0).max(1000).empty('').options({
      language: {
        string: { max: "maximum 1000" },
        any: { required: 'le champ est obligatoire' },
      },
    }).label("Code"),

    subdivisionClasse: Joi.number().integer().min(1).required().empty('').options({
      language: {
        any: { required: 'le champ est obligatoire' },
        number: { min: "minimum 2 caractères", integer: 'Doit être un nombre entier' },
      },
    }).label("Subdivision"),

    capaciteClasseOption: Joi.number().integer().min(1).required().empty('').options({
      language: {
        any: { required: 'le champ est obligatoire' },
        number: { min: "minimum 2 caractères", integer: 'Doit être un nombre entier' },
      },
    }).label("Capacité"),

    montantClasseOption: Joi.number().integer().min(1).required().empty('').options({
      language: {
        any: { required: 'le champ est obligatoire' },
        string: { number: 'vous devez renseignez un nombre' },
      },
    }).label("Montant"),

    idSite: Joi.number().required("").empty('').options({
      language: {
        any: { required: 'le champ est obligatoire' },
      },
    }).label("Site"),
  };

  //####END GESTION DES REGLES DE VALIDATIONS ###########///


  const fetchClasses = async () => {
    await ClassesService.index(token)
      .then((res) => {
        //console.log(res.data.data)
        setClasses(res.data.data.classes);

      })
      .catch((error) => {
        console.log(error);
      });

    //initialize datatable
    $(document).ready(function () {
      $(".data-table").DataTable();
    });
  };


  //get liste statuts
  const fetchStatuts = async () => {
    await StatutsService.index(token).then((res) => {
      setStatuts(res.data.data.statuts)
    }).catch(error => {
      console.log(error)
    })
  }

  //get liste statuts
  const fetchSites = async () => {
    await SitesService.index(token).then((res) => {
      //console.log('sites:', res.data.data)
      setSites(res.data.data)
    }).catch(error => {
      console.log(error)
    })
  }

  //Gérer les changements sur les formulaires d'ajout
  const handleChange = (event) => {
    //console.log(name)
    const { name, value } = event.target;

    setAddFormData({ ...addFormData, [name]: value });

    let errorData = { ...errors };
    const errorMessage = validateProperty(event);
    //En cas d'erreur les afficher
    if (errorMessage) {
      errorData[name] = errorMessage;
    } else {
      //Sinon supprimer l'erreur existant
      delete errorData[name];
    }

    let customerData = { ...addFormData };
    customerData[name] = event.target.value;
    setAddFormData(customerData);
    setErrors(errorData);

  }


  //Vérifie si la règle de validation est validé ou pas
  const validateProperty = (event) => {
    const { name, value } = event.target;
    const obj = { [name]: value };
    const subSchema = { [name]: schemaAddData[name] };
    const result = Joi.validate(obj, subSchema);
    const { error } = result;
    return error ? error.details[0].message : null;
  };

  //Une fonction pour vider les champs du formulaire
  const clearForm = () => {
    setAddFormData({
      libelleClasse: '',
      descriptionClasse: '',
      codeClasse: '',
      subdivisionClasse: '',
      capaciteClasseOption: '',
      montantClasseOption: '',
      idSite: ''
    });
  };


  //Gérer les changements sur les formulaires de modification
  const handleEditChange = (event) => {
    const { name, value } = event.target;
    setEditFormData({ ...editFormData, [name]: value });
    //console.log(editFormData)
    let errorData = { ...errors };
    const errorMessage = validateEditProperty(event);
    //En cas d'erreur les afficher
    if (errorMessage) {
      errorData[name] = errorMessage;
    } else {
      //Sinon supprimer l'erreur existant
      delete errorData[name];
    }

    let customerData = { ...editFormData };
    customerData[name] = event.target.value;
    setEditFormData(customerData);
    setErrors(errorData);

  }


  //Vérifie si la règle de validation est validé ou pas
  const validateEditProperty = (event) => {
    const { name, value } = event.target;
    const obj = { [name]: value };
    const subSchema = { [name]: schemaEditData[name] };
    const result = Joi.validate(obj, subSchema);
    const { error } = result;
    return error ? error.details[0].message : null;
  };


  //suppression d'un élément
  const onDelete = (param) => {
    //confirm action
    Swal.fire({
      icon: "warning",
      text: "Voulez-vous confirmer cette action ?",
      showCancelButton: true,
      cancelButtonText: "Non",
      confirmButtonText: "Oui",
      confirmButtonColor: "red",
    }).then((result) => {
      if (result.isConfirmed) {
        ClassesService.delete(param, token)
          .then((response) => {
            //console.log(response.data)
            if (response.data.status !== 200) {
              Swal.fire({
                icon: "error",
                text: response.data.message,
              });
            } else {
              Swal.fire({
                icon: "success",
                text: response.data.message,
              });
              fetchClasses();
            }
          })
          .catch((e) => {
            Swal.fire({
              icon: "error",
              text: e.message,
            });
            console.log(e);
          });
      }
    });
  };


  //Enregistrer une classe
  const handleSubmit = async (event) => {
    event.preventDefault()
    //Check si les règles de validations sont respectées avant soumission du formulaire
    const result = Joi.validate(addFormData,
      schemaAddData, { abortEarly: false });
    //console.log(result);
    const { error } = result;
    if (error) {
      const errorData = {};
      for (let item of error.details) {
        const name = item.path[0];
        const message = item.message;
        errorData[name] = message;
      }
      //console.log(errors);
      setErrors(errorData);
      return errorData;
    } else {
      //
      await ClassesService.store(addFormData, token).then((response) => {
        //console.log(response.data.data)
        //Fermer le modal
        setIsVisible(false)
        if (response.data.status === 200) {
          //Vider les champs du formulaire
          clearForm()
          //Actualiser la liste
          fetchClasses()
          Swal.fire({
            icon: "success",
            text: response.data.message,
            timer: 3000,
          });
        } else {
          Swal.fire({
            icon: "error",
            text: response.data.message,
            showConfirmButton: true,
            timer: 3000,
          });
        }
      }).catch((error) => {
        setIsVisible(false)
        Swal.fire({
          icon: "error",
          text: error.message,
        });
        //affichage des erreurs sur le formulaire
        //setValidationError(error.message)
      });
    }

  }

  ///Content du modal d'ajout de classe
  const addModalContent = (
    <Form className="needs-validation" noValidate onSubmit={handleSubmit}>
      <div className="row">
        <div className=" col-md-6 mb-3">
          <Form.Label
            className="form-label fw-bold"
            htmlFor="bs-validation-name"
          >
            Libelle <i className="text-danger">*</i>
          </Form.Label>
          <Form.Control
            className="form-control"
            id="bs-validation-libelleClasse"
            type="text"
            value={addFormData.libelleClasse}
            onChange={handleChange}
            placeholder="Exemple : 6ème"
            required={true}
            name="libelleClasse"
          />

          {errors.libelleClasse && (
            <div className="alert alert-danger">
              {errors.libelleClasse}
            </div>
          )}
        </div>

        <div className=" col-md-6 mb-3">
          <Form.Label
            className="form-label fw-bold"
            htmlFor="bs-validation-name"
          >
            Code <i className="text-danger">*</i>
          </Form.Label>
          <Form.Control
            className="form-control"
            id="bs-validation-codeClasse"
            type="text"
            value={addFormData.codeClasse}
            onChange={handleChange}
            placeholder="Exemple : MC"
            required={true}
            name="codeClasse"
          />

          {errors.codeClasse && (
            <div className="alert alert-danger">
              {errors.codeClasse}
            </div>
          )}
        </div>

        <div className=" col-md-6 mb-3">
          <Form.Label
            className="form-label fw-bold"
            htmlFor="bs-validation-name"
          >
            Subdivision <i className="text-danger">*</i>
          </Form.Label>
          <Form.Control className="form-control" id="bs-validation-subdivisionClasse"
            type="number"
            value={addFormData.subdivisionClasse}
            onChange={handleChange}
            required={true}
            name="subdivisionClasse"
          />

          {errors.subdivisionClasse && (
            <div className="alert alert-danger">
              {errors.subdivisionClasse}
            </div>
          )}

        </div>

        <div className=" col-md-6 mb-3">
          <Form.Label
            className="form-label fw-bold"
            htmlFor="bs-validation-name"
          >
            Capacité <i className="text-danger">*</i>
          </Form.Label>
          <Form.Control className="form-control" id="bs-validation-capaciteClasseOption"
            type="number"
            value={addFormData.capaciteClasseOption}
            onChange={handleChange}
            required={true}
            name="capaciteClasseOption"
          />

          {errors.capaciteClasseOption && (
            <div className="alert alert-danger">
              {errors.capaciteClasseOption}
            </div>
          )}

        </div>

        <div className=" col-md-6 mb-3">
          <Form.Label
            className="form-label fw-bold"
            htmlFor="bs-validation-name"
          >
            Sites <i className="text-danger">*</i>
          </Form.Label>
          <Form.Select className="select2 form-select form-select-md" name="idSite" id="bs-validation-idSite" value={addFormData.idSite} onChange={handleChange} required>
            <option value="" disabled>-- Sélectionnez un site --</option>
            {sites.sites && sites.sites.map(item => (
              <option key={item.id} value={item.id}>{item.nomSite}</option>
            ))}
          </Form.Select>

          {errors.idSite && (
            <div className="alert alert-danger">
              {errors.idSite}
            </div>
          )}

        </div>

        <div className=" col-md-6 mb-3">
          <Form.Label
            className="form-label fw-bold"
            htmlFor="bs-validation-name"
          >
            Montant <i className="text-danger">*</i>
          </Form.Label>
          <Form.Control className="form-control" id="bs-validation-montantClasseOption"
            type="number"
            value={addFormData.montantClasseOption}
            onChange={handleChange}
            required={true}
            name="montantClasseOption"
          />

          {errors.montantClasseOption && (
            <div className="alert alert-danger">
              {errors.montantClasseOption}
            </div>
          )}

        </div>

      </div>

      <div className=" mb-3">
        <Form.Label
          className="form-label fw-bold"
          htmlFor="bs-validation-descriptionClasse" >
          Description <i className="text-danger"></i>
        </Form.Label>
        <textarea
          className="form-control"
          id="bs-validation-descriptionClasse"
          onChange={handleChange}
          name="descriptionClasse"
          rows="3"
          value={addFormData.descriptionClasse}
        ></textarea>

        {errors.descriptionClasse && (
          <div className="alert alert-danger">
            {errors.descriptionClasse}
          </div>
        )}
      </div>
      <Modal.Footer className="mt-4">
        <Button variant="secondary" onClick={() => setIsVisible(false)}>
          Fermer
        </Button>
        <Button variant="primary" type="submit">
          Enregistrer
        </Button>
      </Modal.Footer>
    </Form>
  );


  ///Lancer le modal d'edition
  const lauchEdit = async (id) => {
    await ClassesService.show(id, token).then((response) => {
      const data = response.data.data;
      console.log('show:', data);
      setEditFormData({
        id:data.id,
        libelleClasse: data.libelleClasse,
        codeClasse: data.codeClasse,
        descriptionClasse: data.descriptionClasse,
        capaciteClasseOption: data.capaciteClasseOption,
        montantClasseOption: data.montantClasseOption,
        subdivisionClasse: data.subdivisionClasse,
        statutId: data.statuts && data.statuts.id ? data.statuts.id : '',
        idSite: data.sites && data.sites.id ? data.sites.id : '',
        
      })
      setEditModal(true)

    }).catch((error) => {
      Swal.fire({
        icon: "error",
        text: error.message,
      });
    });
  }

  //update fonction
  const handleUpdate = async (event) => {
    event.preventDefault()
    //console.log("okay")
    //Check si les règles de validations sont respectées avant soumission du formulaire
    const result = Joi.validate(editFormData,
      schemaEditData, { abortEarly: false });
    //console.log(result);
    const { error } = result;
    if (error) {
      const errorData = {};
      for (let item of error.details) {
        const name = item.path[0];
        const message = item.message;
        errorData[name] = message;
      }
      //console.log(errors);
      setErrors(errorData);
      return errorData;
    } else {

      //
      await ClassesService.update(editFormData, token).then((response) => {
        //Fermer le modal
        setEditModal(false)

        if (response.data.status !== 200) {
          Swal.fire({
            icon: "error",
            text: response.data.message,
            showConfirmButton: false,
            timer: 3000,
          });

        } else {
          fetchClasses()
          Swal.fire({
            icon: "success",
            text: response.data.message,
            showConfirmButton: false,
            timer: 3000,
          });
        }
      }).catch((error) => {
        //Fermer le modal
        setEditModal(false)

        Swal.fire({
          icon: "error",
          text: error.message,
        });
      });

    }
  };


  ///Content du modal d'edition de matière
  const editModalContent = (
    <Form className="needs-validation" noValidate onSubmit={handleUpdate}>
      <div className="row">
        <div className=" col-md-6 mb-3">
          <Form.Label
            className="form-label fw-bold"
            htmlFor="bs-validation-name"
          >
            Libelle <i className="text-danger">*</i>
          </Form.Label>
          <Form.Control
            className="form-control"
            id="bs-validation-libelleClasse"
            type="text"
            value={editFormData.libelleClasse}
            onChange={handleChange}
            placeholder="Exemple : 6ème"
            required={true}
            name="libelleClasse"
          />

          {errors.libelleClasse && (
            <div className="alert alert-danger">
              {errors.libelleClasse}
            </div>
          )}
        </div>

        <div className=" col-md-6 mb-3">
          <Form.Label
            className="form-label fw-bold"
            htmlFor="bs-validation-name"
          >
            Code <i className="text-danger">*</i>
          </Form.Label>
          <Form.Control
            className="form-control"
            id="bs-validation-codeClasse"
            type="text"
            value={editFormData.codeClasse}
            onChange={handleChange}
            placeholder="Exemple : MC"
            required={true}
            name="codeClasse"
          />

          {errors.codeClasse && (
            <div className="alert alert-danger">
              {errors.codeClasse}
            </div>
          )}
        </div>

        <div className=" col-md-6 mb-3">
          <Form.Label
            className="form-label fw-bold"
            htmlFor="bs-validation-name"
          >
            Subdivision <i className="text-danger">*</i>
          </Form.Label>
          <Form.Control className="form-control" id="bs-validation-subdivisionClasse"
            type="number"
            value={editFormData.subdivisionClasse}
            onChange={handleChange}
            required={true}
            name="subdivisionClasse"
          />

          {errors.subdivisionClasse && (
            <div className="alert alert-danger">
              {errors.subdivisionClasse}
            </div>
          )}

        </div>

        <div className=" col-md-6 mb-3">
          <Form.Label
            className="form-label fw-bold"
            htmlFor="bs-validation-name"
          >
            Capacité <i className="text-danger">*</i>
          </Form.Label>
          <Form.Control className="form-control" id="bs-validation-capaciteClasseOption"
            type="number"
            value={editFormData.capaciteClasseOption}
            onChange={handleChange}
            required={true}
            name="capaciteClasseOption"
          />

          {errors.capaciteClasseOption && (
            <div className="alert alert-danger">
              {errors.capaciteClasseOption}
            </div>
          )}

        </div>

        <div className=" col-md-6 mb-3">
          <Form.Label
            className="form-label fw-bold"
            htmlFor="bs-validation-name"
          >
            Sites <i className="text-danger">*</i>
          </Form.Label>
          <Form.Select className="select2 form-select form-select-md" name="idSite" id="bs-validation-idSite" value={editFormData.idSite} onChange={handleEditChange} required>
            <option value="" disabled>-- Sélectionnez un site --</option>
            {sites.sites && sites.sites.map(item => (
              <option key={item.id} value={item.id}>{item.nomSite}</option>
            ))}
          </Form.Select>

          {errors.idSite && (
            <div className="alert alert-danger">
              {errors.idSite}
            </div>
          )}

        </div>

        <div className=" col-md-6 mb-3">
          <Form.Label
            className="form-label fw-bold"
            htmlFor="bs-validation-name"
          >
            Montant <i className="text-danger">*</i>
          </Form.Label>
          <Form.Control className="form-control" id="bs-validation-montantClasseOption"
            type="number"
            value={editFormData.montantClasseOption}
            onChange={handleChange}
            required={true}
            name="montantClasseOption"
          />

          {errors.montantClasseOption && (
            <div className="alert alert-danger">
              {errors.montantClasseOption}
            </div>
          )}

        </div>

        <div className=" col-md-6 mb-3">
          <Form.Label
            className="form-label fw-bold"
            htmlFor="bs-validation-name"
          >
            Statuts <i className="text-danger">*</i>
          </Form.Label>
          <Form.Select className="select2 form-select form-select-md" name="statutId" id="bs-validation-statutId" value={editFormData.statutId} onChange={handleEditChange} required>
            {statuts.length > 0 && statuts.map(item => (
              <option key={item.id} value={item.id}>{item.libelleStatut}</option>
            ))}
          </Form.Select>

          {errors.statutId && (
            <div className="alert alert-danger">
              {errors.statutId}
            </div>
          )}

        </div>
      </div>

      <div className=" mb-3">
        <Form.Label
          className="form-label fw-bold"
          htmlFor="bs-validation-descriptionClasse" >
          Description <i className="text-danger"></i>
        </Form.Label>
        <textarea
          className="form-control"
          id="bs-validation-descriptionClasse"
          onChange={handleEditChange}
          name="descriptionClasse"
          rows="3"
          value={editFormData.descriptionClasse}
        ></textarea>

        {errors.descriptionClasse && (
          <div className="alert alert-danger">
            {errors.descriptionClasse}
          </div>
        )}
      </div>
      <Modal.Footer className="mt-4">
        <Button variant="secondary" onClick={() => setEditModal(false)}>
          Fermer
        </Button>
        <Button variant="primary" type="submit">
          Enregistrer
        </Button>
      </Modal.Footer>
    </Form>
  );


  useEffect(() => {
    fetchClasses();
    fetchStatuts();
    fetchSites()
    // Vérifier si l'utilisateur est connecté lors du chargement de l'application
    dispatch(checkAuthenticate());
    if (!isAuthenticated) {
      //console.log(isAuthenticated)
      //Redirection sur le dashboard
      navigate(myroutes.login);
    }

  }, [dispatch]);

  return (
    <Layout>
      <div className="container-xxl flex-grow-1 container-p-y">
        <Filarial activeLink={activeLink} />


        {/* Responsive Datatable */}
        <div className="card mb-3 mt-2 shadow">
          <h5 className="card-header">
            Liste des classes &nbsp; &nbsp; &nbsp;  <Button variant="primary" onClick={() => setIsVisible(true)}>
              <FontAwesomeIcon icon="fa-solid fa-circle-plus" /> Ajouter une classe
            </Button>
          </h5>

          <div className="card-datatable table-responsive px-4 pb-3">
            <table className="dt-responsive table border-top data-table table-hover ">
              <thead className="bg-primary">
                <tr style={{ color: "white" }}>
                  <th className="cell text-white">#</th>
                  <th className="cell text-white">Libelle</th>
                  <th className="cell text-white">Subdivision</th>
                  <th className="cell text-white">Description</th>
                  <th className="cell text-white">Statuts</th>
                  <th className="cell text-white">Date modifcation</th>
                  <th className="cell text-white">Action</th>
                </tr>
              </thead>
              <tbody>
                {classes.length > 0 &&
                  classes.map((item, index) => (
                    <tr key={index}>
                      <td className="cell">{index + 1}</td>
                      <td className="cell">{item.libelleClasse}</td>
                      <td className="cell">{item.subdivisionClasse}</td>
                      <td className="cell">
                        <span className="truncate">{item.descriptionClasse}</span>
                      </td>
                      <td className="cell">
                        <span class={item.statuts?.libelleStatut === "ACTIF" ? 'badge rounded-pill bg-success' : 'badge rounded-pill bg-warning'}>{item.statuts?.libelleStatut}</span>
                      </td>
                      <td className="cell">
                        <span>
                          {dayjs(item.updatedAt).format("DD/MM/YYYY H:m:s")}
                        </span>
                      </td>
                      <td className="cell">
                        <Button onClick={() => lauchEdit(item.id)}
                          className="btn btn-sm" severity="warning" style={{ color: "white" }}
                          title="Modifier"
                        >
                          <i className="fas fa-edit"></i>
                        </Button> &nbsp; &nbsp;
                        <Button
                          className="btn btn-sm" style={{ backgroundColor: "red", color: "white", border: "1px solid red" }}
                          onClick={() => onDelete(item.id)}
                          title="Supprimer"
                        >
                          <i className="fas fa-trash"></i>
                        </Button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
        {/*/ Responsive Datatable */}
      </div>

      {/* Modal Ajout des classes*/}
      <CustomAddModal
        modalTitle="Enregistrement classe"
        modalContent={addModalContent}
        visible={isVisible}
        close={() => setIsVisible(false)}
      />

      {/**End Modal Ajout des classes*/}

      {/* Modal Edition des classes*/}
      <CustomEditModal
        modalTitle="Modification classe"
        modalContent={editModalContent}
        visible={editModal}
        close={() => setEditModal(false)}
      />

      {/**End Modal Edition des classes*/}
    </Layout>
  );
}
